import React , {useState , useEffect} from 'react';
import Map, {NavigationControl  , FullscreenControl, Marker, Popup } from 'react-map-gl';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import './MapSection.css';
import { getDocs , collection , db  } from '../firebase';


const MapSection = () => {
  const [ markersArray , setMarkersArray ] = useState([]);

  const [showPopup, setShowPopup] = useState(false);

  const  [nameValue ,  setNameValue] = useState('');
  const  [longVal ,  setLongVal] = useState('');
  const  [latVal ,  setLatVal] = useState('');


   const handleMarkClick = ( name , long , lat ) => {
  
    setNameValue(name);
    setLongVal(long);
    setLatVal(lat);
    setShowPopup(true);

   }


  useEffect(  () => {

    const getMarkersData = async () => { 
      const querySnapshot = await getDocs(collection(db, "markers"));
      const usersDataArray = querySnapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }));
        
      setMarkersArray(usersDataArray);
     
    }
    getMarkersData();
  } , []);

 

  return (
    <div className='mt-2 mab_section' >

      

<Map  mapLib={maplibregl} 
        initialViewState={{
          longitude: 42.6666674,
            latitude: 17.333333,
            zoom: 7.2
        }}
        
        style={{width: "100%", height: "75vh"  }}
        mapStyle={'https://api.maptiler.com/maps/bright-v2/style.json?key=zcK1SXnMzuUNV1RcYU2I'}
      >
     <FullscreenControl />
  
    {markersArray && markersArray.map(( { id  , langitude , lattiude  , name } ) => (
        <Marker key={id}  longitude={langitude} latitude={lattiude} anchor="bottom" onClick={() => handleMarkClick(name , langitude , lattiude) }   >
      <img className='icon_smaller borderd_map_icon' src={'/images/icons/location-pin.png'} />
    </Marker>
      )) }
  
        <NavigationControl position="top-left" />

        {showPopup && (
      <Popup longitude={longVal} latitude={latVal}
        anchor="bottom"
        onClose={() => setShowPopup(false)}>
        {nameValue}
      </Popup>)}

      </Map>

   
    


    </div>
  )
}

export default MapSection